export const textSizeLabels = [
  'text-size-80',
  'text-size-90',
  'text-size-100',
  'text-size-200',
  'text-size-300',
  'text-size-400',
  'text-size-500',
  'text-size-600',
  'text-size-700'
]
